angular.module('tf.game.service', [])
       .service('leaderBoardService', ["$uibModal", "$http", leaderBoardService]);

function leaderBoardService($uibModal, $http) {

    function confirmLeave() {
        var instance = $uibModal.open({
            template: modalTemplate,
            size: 'md',
            backdrop: 'static'
        });
        return instance.result
    }

    function leaveLeague(id) {
        return confirmLeave().then(function () {
            var url = '/tradefloor/api/leaderboards/' + id + '/leave';
            return $http.post(url);
        })
    }

    function joinLeague(league, pin) {
        var url = '/tradefloor/api/leaderboards/' + league + '/join';
        var params = {};
        if (pin != null) {
            params.pin = pin;
        }
        return $http.post(url, null, {params: params});
    }

    return {
        leaveLeague: leaveLeague,
        joinLeague: joinLeague
    }
}

var modalTemplate = "" +
    "<div class=\"modal-header\">\n" +
    "    <h3 class=\"modal-title\">\n" +
    "        <i class=\"icon-help_outline\"></i> \n" +
    "        Leave Group\n" +
    "    </h3>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <p>\n" +
    "        Are you sure you want to leave the group?    \n" +
    "    </p>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$close(true)\">Yes</button>\n" +
    "    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$dismiss(false)\">No</button>\n" +
    "</div>\n";
